import React, { useState } from "react";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/Products.css";
import Modal from "../components/Modal";

const Products = () => {
  const [products, setProducts] = useState([
    { id: 1, name: "产品1", price: 100, date: new Date() },
    { id: 2, name: "产品2", price: 200, date: new Date() },
  ]);
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    date: new Date(),
  });
  const [editingId, setEditingId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [queryStartDate, setQueryStartDate] = useState(null);
  const [queryEndDate, setQueryEndDate] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(products);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({ ...prev, date }));
  };

  const handleQuickDateSelect = (option) => {
    const today = new Date();
    let startDate = new Date();
    switch (option) {
      case "last7days":
        startDate.setDate(today.getDate() - 7);
        break;
      case "last30days":
        startDate.setDate(today.getDate() - 30);
        break;
      case "last3months":
        startDate.setMonth(today.getMonth() - 3);
        break;
      case "last6months":
        startDate.setMonth(today.getMonth() - 6);
        break;
      case "lastYear":
        startDate.setFullYear(today.getFullYear() - 1);
        break;
      default:
        startDate = null;
    }
    setQueryStartDate(startDate);
    setQueryEndDate(today);
    if (startDate) {
      const startTime = startDate.getTime();
      const endTime = today.getTime();
      const filtered = products.filter((product) => {
        const productTime = new Date(product.date).getTime();
        return productTime >= startTime && productTime <= endTime;
      });
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  };

  const handleQuery = () => {
    if (!queryStartDate || !queryEndDate) {
      setFilteredProducts(products);
      return;
    }
    const startTime = new Date(queryStartDate).getTime();
    const endTime = new Date(queryEndDate).getTime();
    const filtered = products.filter((product) => {
      const productTime = new Date(product.date).getTime();
      return productTime >= startTime && productTime <= endTime;
    });
    setFilteredProducts(filtered);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editingId) {
      setProducts(
        products.map((p) =>
          p.id === editingId
            ? { ...p, ...formData, price: Number(formData.price) }
            : p
        )
      );
      setEditingId(null);
    } else {
      const newProduct = {
        id: Date.now(),
        ...formData,
        price: Number(formData.price),
      };
      setProducts([...products, newProduct]);
    }
    setFormData({ name: "", price: "", date: new Date() });
    setIsModalOpen(false);
    setFilteredProducts(products);
  };

  const handleEdit = (product) => {
    setFormData({
      name: product.name,
      price: product.price,
      date: new Date(product.date),
    });
    setEditingId(product.id);
    setIsModalOpen(true);
  };

  const handleDelete = (id) => {
    setProducts(products.filter((p) => p.id !== id));
    setFilteredProducts(filteredProducts.filter((p) => p.id !== id));
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("zh-CN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingId(null);
    setFormData({ name: "", price: "", date: new Date() });
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  const sortedProducts = React.useMemo(() => {
    if (!sortConfig.key) return filteredProducts;
    const sorted = [...filteredProducts].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];
      if (sortConfig.key === "date") {
        aValue = new Date(aValue).getTime();
        bValue = new Date(bValue).getTime();
      }
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredProducts, sortConfig]);

  return (
    <div className="page-container">
      <h1>产品管理</h1>

      <div className="page-links">
        <Link
          to={{
            pathname: "/data",
            search: "?type=products&source=product_management",
          }}
          className="page-link"
        >
          查看数据列表
        </Link>
        <Link
          to={{
            pathname: "/user",
            search: "?page=products&action=view",
          }}
          className="page-link"
        >
          用户中心
        </Link>
        <Link
          to={{
            pathname: "/settings",
            search: "?section=products&tab=general",
          }}
          className="page-link"
        >
          系统设置
        </Link>
      </div>

      <div className="query-container">
        <div className="date-picker-container">
          <DatePicker
            selected={queryStartDate}
            onChange={setQueryStartDate}
            dateFormat="yyyy-MM-dd"
            placeholderText="开始日期"
            className="date-picker"
          />
          <DatePicker
            selected={queryEndDate}
            onChange={setQueryEndDate}
            dateFormat="yyyy-MM-dd"
            placeholderText="结束日期"
            className="date-picker"
          />
          <button onClick={handleQuery}>查询</button>
        </div>
        <div className="quick-date-options">
          <button onClick={() => handleQuickDateSelect("last7days")}>
            最近 7 天
          </button>
          <button onClick={() => handleQuickDateSelect("last30days")}>
            最近 1 个月
          </button>
          <button onClick={() => handleQuickDateSelect("last3months")}>
            最近 3 个月
          </button>
          <button onClick={() => handleQuickDateSelect("last6months")}>
            最近 6 个月
          </button>
          <button onClick={() => handleQuickDateSelect("lastYear")}>
            最近 1 年
          </button>
        </div>
      </div>

      <button
        className="add-product-btn"
        onClick={() => {
          setEditingId(null);
          setFormData({ name: "", price: "", date: new Date() });
          setIsModalOpen(true);
        }}
      >
        添加新产品
      </button>

      <table className="product-table">
        <thead>
          <tr>
            <th onClick={() => handleSort("id")}>
              ID{" "}
              {sortConfig.key === "id"
                ? sortConfig.direction === "asc"
                  ? "↑"
                  : "↓"
                : null}
            </th>
            <th onClick={() => handleSort("name")}>
              名称{" "}
              {sortConfig.key === "name"
                ? sortConfig.direction === "asc"
                  ? "↑"
                  : "↓"
                : null}
            </th>
            <th onClick={() => handleSort("price")}>
              价格{" "}
              {sortConfig.key === "price"
                ? sortConfig.direction === "asc"
                  ? "↑"
                  : "↓"
                : null}
            </th>
            <th onClick={() => handleSort("date")}>
              日期{" "}
              {sortConfig.key === "date"
                ? sortConfig.direction === "asc"
                  ? "↑"
                  : "↓"
                : null}
            </th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {sortedProducts.map((product) => (
            <tr key={product.id}>
              <td>{product.id}</td>
              <td>{product.name}</td>
              <td>{product.price}</td>
              <td>{formatDate(product.date)}</td>
              <td>
                <button onClick={() => handleEdit(product)}>编辑</button>
                <button onClick={() => handleDelete(product.id)}>删除</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <h2>{editingId ? "编辑产品" : "添加新产品"}</h2>
        <form onSubmit={handleSubmit} className="product-form">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="产品名称"
            required
          />
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleInputChange}
            placeholder="价格"
            required
          />
          <div className="date-picker-container">
            <DatePicker
              selected={formData.date}
              onChange={handleDateChange}
              dateFormat="yyyy-MM-dd"
              placeholderText="选择日期"
              className="date-picker"
            />
          </div>
          <button type="submit">{editingId ? "更新" : "添加"}</button>
        </form>
      </Modal>
    </div>
  );
};

export default Products;
